// 避免流水线脚本执行失败
const enMerged = {};
try {
    const ctx = require.context('./en', false, /\.ts$/);
    ctx.keys().forEach((key) => {
        const { en } = ctx(key);
        if (!en) {
            throw Error(`${key} not export en`);
        }
        Object.assign(enMerged, en);
    });
}
catch (error) {
    console.log(error);
}
export { enMerged };
